import store from '../store/Store';

/**
 * Util to get published status of the booking page from store.
 * Temporary solution:
 * New user turns on publish booking page by default
 * While initially creating an new active directory entry, IsAnoymouseSharingEnable returns false
 */
export default function getPublishedStatus(): boolean {
    const settings = store.pbpPublishingSetting.publishingSettings;
    // Anonymous sharing is being incorrectly set, made WI to set it correctly
    // TODO after WI is done, add this statement back store.pbpPublishingSetting.isAnonymousSharingEnabled
    return settings?.IsPublished || false;
}
